export const wrapRootElement = require('./src/wrapRootElement').wrapRootElement;
